angular.module('bmsApp.marketing').controller('RemoteCampaignIndexCtrl', function ($scope,
																				   $rootScope,
																				   $timeout,
																				   $log,
																				   MarketingSchemeSvc,
																				   LicenseOptionsSvc,
																				   ngTableParams,
																				   $state,
																				   $window,
																				   $cookies,
																				   $localStorage) {

	$scope.campaigns = {};
	$scope.loading = false;
	$scope.updating = false;
	$scope.campaignCount = 0;

	var defaultCampaignParams = function () {
		return {
			page: 1, // show first page
			count: $scope.config.table.params.count, // count per page
			sorting: {
				id: 'desc' // initial sorting
			},
			filter: {
				search: '',
				// license: 0
			}
		};
	};

	LicenseOptionsSvc.license().then(function(response) {
		$scope.licenses = response.data.options;
	});


	var initialCampaignParams = function () {
		if (angular.isDefined($localStorage.remoteCampaignIndexParams)) {
			return angular.extend({}, defaultCampaignParams(), $localStorage.remoteCampaignIndexParams);
		}
		else {
			return angular.extend({}, defaultCampaignParams());
		}
	};

	var params = initialCampaignParams();

	// copy the filters to a workable state
	$scope.campaignFilters = angular.copy(params.filter);

	$scope.valueSlider = {
		floor: 0,
		ceil: 50000,
		format: function (value) {
			return '£' + value;
		}
	};

	$scope.tableParams = new ngTableParams(params, {
		total: 0, // length of data
		counts: $scope.config.table.settings.counts, // available page counts
		getData: function ($defer, params) {
			$localStorage.remoteCampaignIndexParams = params.$params;
			MarketingSchemeSvc.index(params.$params)
				.then(function (response) {
					params.total(response.data.filtered_count);
					$scope.schemeCount = response.data.filtered_count;
					$scope.schemes = response.data.scheme_collection;

					var tableCount = {
						total: $scope.schemeCount,
						page: response.data.scheme_collection.length
					};

					$scope.scheme_total_count = response.data.total_count;

					$scope.$emit('campaignIndexUpdated', tableCount);
					$defer.resolve(response.data.scheme_collection);

					// Check if we've exceeded our page size, if we have, go back
					if (response.data.filtered_count > 0 && !response.data.scheme_collection.length) {
						let newParams = angular.copy($scope.tableParams.$params);
						newParams.page--;
						angular.extend($scope.tableParams.$params, newParams);
					}
					$scope.updating = false;
				});
		}
	});

	// Store the table params whenever anything changes
	$scope.$watch('tableParams.$params', function (value) {
		if (angular.isObject(value)) {
			$cookies.campaignIndexParams = JSON.stringify(value);
		}
	}, true);

	// text search
	$scope.filterChanged = function () {
		$scope.tableParams.$params.filter.search = $scope.campaignFilters.search;
	};

	$scope.filterApply = function () {
		angular.extend($scope.tableParams.$params.filter, angular.copy($scope.campaignFilters));
	};

	$scope.filterToggled = function (open) {
		if (open) {
			$timeout(function () {
				$scope.$broadcast('rzSliderForceRender');
			}, 500);
		}
	};

	$scope.rowClicked = function (scheme) {
		$state.go("main.marketing.remoteCampaignIndex.overview", {schemeId: scheme.id});
	};

	$scope.export = function ($event, group) {
		$window.location.href = '/api/marketing/advertisingGroup/export/' + group.id;
		$event.stopPropagation();
	};

	$scope.filterReset = function () {
		angular.extend($scope.tableParams.$params, defaultCampaignParams());
		angular.extend($scope.campaignFilters, defaultCampaignParams().filter);
		$scope.campaignFilters.budget.max = $scope.valueSlider.ceil;
	};

});
